import React, { useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../../../../components/common/button/CustomButtons';
import ChildHeader from '../../../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../../../components/common/FilterBy';
import { SearchBar } from '../../../../../components/common/SearchBar';
import {
  CustomPagination,
  TableCustom,
} from '../../../../../components/common';
import useDebounce from '../../../../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import ModalInput from './ModalInput';
import ModalCustom from '../../../../../components/common/Modal';
import { useQuery } from '../../../../../hooks/UseQuery';
import useConfirm from '../../../../../components/common/useConfirm';

import { IData } from './Interface';
import CustomTileButton from '../../../../../components/common/button/CustomTileButton';
import DescriptionIcon from '@mui/icons-material/Description';
import { usePermission } from '../../../../../utils/helpers/usePermission';
const tableHeaderObj = [
  [
    { text: '#', rowspan: 1, colspan: 1 },
    { text: 'Name', rowspan: 1, colspan: 1 },
    { text: 'Department', rowspan: 1, colspan: 1 },
    { text: 'Add Topic', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [
  { value: 'createdAt', name: 'A-Z' },
  { value: 'faculty_name', name: 'Name' },
];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [tniTopicId, setTNITopicId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);

  const search = useQuery('search');
  const filter = useQuery('filter');
  const page = useQuery('page') || 1;

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE TNI',
    'Are you sure you want to delete this?',
  );
  const navigate = useNavigate();

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/tni/getAllTopicPaper/list/?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}`,
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const deleteTNITopic = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/tni/deleteTopicPaper/${id}`)
      .then((res) => {
        alert('TNI deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [page, search, render, isModal]);

  return (
    <>
      <ChildHeader text="TNI TOPIC LIST">
        <AddButton onClick={() => setIsModal(true)} label="New Topic Paper" />
      </ChildHeader>
      <SearchFilterContainer filter={false}>
        <SearchBar label="Search By Name" />
        {/* <FilterBy options={filterOptions} /> */}
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IData, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">{item?.topic_paper_name}</TableCell>
                  <TableCell align="center">
                    {item?.area_of_work?.department_name}
                  </TableCell>
                  <TableCell align="center">
                    <CustomTileButton
                      label="Add TNI Topics"
                      icon={<DescriptionIcon />}
                      url={`/common/createEditTopicPaper/${item._id}`}
                      sx={{
                        background: '#003566',
                        color: '#fafafa',
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <EditIconButton
                        tooltipTitle="EDIT"
                        onClick={() => {
                          setTNITopicId(item?._id || '');
                          setIsModal(true);
                        }}
                      />
                      <ViewIconButton
                        tooltipTitle="View Topic paper"
                        onClick={() => {
                          navigate(
                            `/common/quick_view_topic_paper/${item._id}`,
                          );
                        }}
                      />
                      <DeleteIconButton
                        tooltipTitle="DELETE"
                        onClick={() => {
                          deleteTNITopic(item?._id || '');
                        }}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setTNITopicId(null);
          setIsModal(false);
        }}
        title="CREATE NEW PAPER"
      >
        <ModalInput id={tniTopicId} setIsModal={setIsModal} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
